import { client } from '@/common-utils/libraries/axios/axios';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import { REMOTE_COLLECTION } from '../apiUrls';

const mutationSendRemoteCollectionByMail = (onSuccess, onError) => {
    return {
        mutationFn: ({ remoteCollectionId, provider, emails }) => {
            return client.post(replaceParameters(
                REMOTE_COLLECTION.SEND_MAIL.url, { remoteCollectionId: remoteCollectionId }),
                { provider: provider, recipients: emails.join(',') }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSendRemoteCollectionByMail;